module.exports = __webpack_public_path__ + "static/neonatal-2-43ec2f095332c918fd779e87dbc8948b.png";